import { PageGroup } from "./transaction"

export enum PageId {
  DefaultPage = "DefaultPage",

  // Runway Availability menu
  AvailBaseline = "AvailBaseline",
  AvailWeek = "AvailWeek",
  AvailWeekOOH = "AvailWeekOOH",
  AvailWeekHour = "AvailWeekHour",
  AvailDoop = "AvailDoop",
  AvailTime = "AvailTime",
  AvailSeasonHour = "AvailSeasonHour",

  // Pax Availability menu
  //   TermAvailWeek = "TermAvailWeek",
  //   TermAvailWeekHour = "TermAvailWeekHour",
  //   TermAvailDoop = "TermAvailDoop",
  //   TermAvailTime = "TermAvailTime",
  //   TermAvailSeasonHour = "TermAvailSeasonHour",

  // Flight Options menu
  ViewFlights = "ViewFlights",
  ViewFlightsEUACA = "ViewFlightsEUACA", // EUACA
  ViewFlightsBaseline = "ViewFlightsBaseline",
  DownloadFlights = "DownloadFlights",
  // DownloadAirport = "DownloadAirport",
  DownloadCancelled = "DownloadCancelled",
  ScheduleDownload = "ScheduleDownload", // OSCAR
  FlightAvail = "FlightAvail",
  AddFlightsSD = "AddFlightsSD",
  AddDepArrFlightsSD = "AddDepArrFlightsSD",
  AddFlightDepArr = "AddFlightDepArr",
  AddFlightsSeries = "AddFlightsSeries",
  AddDepArrFlightsSeries = "AddDepArrFlightsSeries",
  AddSHL = "AddSHL",
  EditFlightsSeries = "EditFlightsSeries",
  EditFlightsSD = "EditFlightsSD",
  EditOffers = "EditOffers",
  EditSHL = "EditSHL",
  SlotMonitor = "SlotMonitor",
  CountReport = "CountReport",
  //   Waitlist = "Waitlist",

  // GA/BA Flights menu
  ViewFlightsGABA = "ViewFlightsGABA",
  AddFlightsGABA = "AddFlightsGABA",
  AddFlightGABATurnaround = "AddFlightGABATurnaround", // Obsolete
  AddDepArrFlightsGABA = "AddDepArrFlightsGABA", // Obsolete ?
  EditFlightsGABA = "EditFlightsGABA",

  // PPR Handling menu
  ViewHandling = "ViewHandling",
  AddHandling = "AddHandling",
  EditHandling = "EditHandling",
  DownloadCancelledHandling = "DownloadCancelledHandling",

  //Airport menu
  DisableMP = "DisableMP",

  // Information
  About = "ext_AboutUs",
  HowToApply = "eAIN",
  Cookies = "ext_Cookies",
  Disclaimer = "ext_Disclaimer",
  //   SystemInfo = "eASI",
  //   Charges = "eACH",
  //   Security = "eASC",
  //   TechReq = "eATR",
  //   Support = "eASQ",
  //   App = "eAAP",

  // Help
  ContactUs = "ext_ContactUs",
  FAQS = "ext_FAQS",
  //    Feedback = "ext_Feedback",

  // Administration menu
  //    AdmServiceLog = "AdmServiceLog",
  //    AdmScheDown = "AdmScheDown",
  //    LogScheDown = "LogScheDown",

  // Login menu
  Login = "Login",
  LogoutPage = "LogoutPage",

  // Internal pages
  DetailWeek = "DetailWeek",
  DetailWeekOOH = "DetailWeekOOH",
  DetailSeason = "DetailSeason",
  //    ChangeScreen = "ChangeScreen",
  RequestResponse = "RequestResponse",
  All = "All" //used for not specific page search history
}

export enum HandlingApp {
  FRAPORTGR = "FRAPORTGR"
}

interface ITransactionPageGroup {
  pageGroup: PageGroup
  pages: PageId[]
}

const transactionPageGroups: ITransactionPageGroup[] = [
  {
    pageGroup: PageGroup.SERIES,
    pages: [PageId.AddFlightsSeries, PageId.EditFlightsSeries]
  },
  {
    pageGroup: PageGroup.GABA,
    pages: [PageId.AddFlightsGABA, PageId.EditFlightsGABA]
  },
  {
    pageGroup: PageGroup.SINGLEDATE,
    pages: [PageId.AddFlightsSD, PageId.EditFlightsSD]
  },
  {
    pageGroup: PageGroup.SHL,
    pages: [PageId.AddSHL, PageId.EditSHL]
  },
  {
    pageGroup: PageGroup.OFFERS,
    pages: [PageId.EditOffers]
  },
  {
    pageGroup: PageGroup.DOWNLOAD,
    pages: [
      PageId.DownloadCancelled,
      PageId.DownloadCancelledHandling,
      PageId.DownloadFlights,
      PageId.CountReport,
      PageId.SlotMonitor,
      PageId.ScheduleDownload
    ]
  },

  {
    pageGroup: PageGroup.HANDLING,
    pages: [PageId.ViewHandling, PageId.AddHandling, PageId.EditHandling]
  }
]

export function handleGetTransactionPageGroup(pageId: PageId): PageGroup {
  const selectedPageGroup = transactionPageGroups.find((tpg) =>
    tpg.pages.includes(pageId)
  )

  return selectedPageGroup ? selectedPageGroup.pageGroup : null
}
